import { createFileRoute } from '@tanstack/react-router';
import IntegrationConfigsView from '../admin/integration-configs/view';
export const Route = createFileRoute('/admin/integrations/configs')({
  component: IntegrationConfigsView,
});
